import { CellData, ComponentData, TabData } from '@ddt-web/data-service';
import * as get from 'lodash/get';
import * as isNil from 'lodash/isNil';

export interface ScenarioData {
	headersX: CellData[];
	cells: CellData[][];
}

export class ScenarioFilterer {
	/**
	 * Filters to the scenarios selected by the user, stored in the url
	 * @param tabData
	 */
	public static filterSelectedScenarios(tabData: TabData): ScenarioData {
		const indexesToKeep = [];
		const rawSelectedScenarios: Array<string> = new URLSearchParams(window.location.search).getAll('stressTest')[0].split(',');
		if (rawSelectedScenarios[0] === 'list') {
			rawSelectedScenarios.shift();
		}

		const headersX = get(tabData, 'tableData[0].headersX');
		let filteredHeadersX: CellData[] = [];
		rawSelectedScenarios.forEach(key => {
			const scenarioIdx: number = headersX.findIndex(cell => (get(cell, 'rawValue') || ''.toString()) === key);
			indexesToKeep.push(scenarioIdx);
			filteredHeadersX = [...filteredHeadersX, headersX[scenarioIdx]];
		});

		const filteredCells = tabData.tableData[0].cells.map(row => indexesToKeep.map(index => row[index]));
		return { headersX: filteredHeadersX, cells: filteredCells } as ScenarioData;
	}

	/**
	 * Gives back an array of indexes of rows to keep based on the selected asset classes by the user in the url
	 * @param componentData
	 * @param dontFilterUserPortfolios false if we don't want the indexes of the user portfolios too, true if we want them in as well
	 */
	public static filterSelectedAssetClassesIndex(componentData: ComponentData, dontFilterUserPortfolios: boolean = false): Array<number> {
		const rawSelectedAssetClassesString: string = new URLSearchParams(window.location.search).getAll('assetClass')[0];
		const rawSelectedAssetClasses: Array<string> = rawSelectedAssetClassesString && rawSelectedAssetClassesString !== 'empty' ? rawSelectedAssetClassesString.split(',') : [];

		if (rawSelectedAssetClasses[0] === 'list') {
			rawSelectedAssetClasses.shift();
		}

		const ports = get(componentData, 'portfolioData', []);
		const nameColIndex = ports.length ? ports[0].findIndex(column => column.config.id === 'name') : null;

		const filteredIdx = ports
			.map((port, i) => {
				const isValidName = !isNil(get(port, `[${nameColIndex}].rawValue`)); // remove invalid asset classes (eg if user messes up with the URL query params/ asset class not available anymore), otherwise, empty rows will show up in PDF
				const isSelected = rawSelectedAssetClasses.includes(port[1].rawValue.split(':').pop()) || (port[2].rawValue !== 'ASSET_CLASS' && dontFilterUserPortfolios);

				if (isValidName && isSelected) {
					return i;
				}
			})
			.filter(idx => {
				return idx !== undefined;
			});

		return filteredIdx;
	}
}
